const trustedDomains = ['shelters.finance', 'numequo.com']

export const isTrustedDomain = (url: string): boolean => {
  try {
    const parsedUrl = new URL(url)
    return trustedDomains.some(
      (domain) =>
        parsedUrl.hostname === domain ||
        parsedUrl.hostname.endsWith(`.${domain}`),
    )
  } catch (e) {
    return false
  }
}

export const getExternalLinkRel = (url: string) =>
  url.startsWith('/') || isTrustedDomain(url)
    ? undefined
    : 'noopener external nofollow'
